<template>
  <nav class="pdl-steps pb-2 flex w-full justify-center" :aria-label="label">
    <ol class="pdl-steps__list">
      <!-- @slot Use this slot to include PdlStepsItems. An error will be thrown for any other children. -->
      <slot />
    </ol>
  </nav>
</template>

<script>
import {PdlStepsItem} from '..';
import Key from './Key'; // This is a symbol that ensures our provide/inject is scoped to this singular usage of PdlSteps/PdlStepsItem

export default {
  name: 'PdlSteps',

  provide() {
    return {
      [Key]: this.state,
    };
  },
  props: {
    /**
     * When true, all steps besides the current step are clickable.
     */
    nonLinear: {
      type: Boolean,
      default: false,
    },
    /**
     * The index of the step which is currently active.
     */
    modelValue: {
      type: Number,
      validator: (n) => Number.isInteger(n) && n >= 0,
      default: 0,
    },
    /**
     * An optional label for the steps to describe the context of the steps. This will be added to an `aria-label` on the `<nav>` element.
     */
    label: {
      type: String,
      default: undefined,
    },
  },
  data() {
    let vm = this;
    return {
        PdlStepsItem,
        state: {
          nonLinear: this.nonLinear,
          get currentStep() {
            return vm.modelValue;
          },
          set currentStep(step) {
            /**
             * Emitted whenever currentStep changes. Args: The index of the new currentStep.
             */
          vm.$emit('update:modelValue', step);
          },
        },
      };
    },
    emits: ['update:modelValue'],

};
</script>

<style lang="scss">
@import 'Steps.scss';
</style>
